<label class="checkbox"
       [class._disabled]="disabled">

    <input type="checkbox"
           [ngModel]="checked"
           (ngModelChange)="onCheckedChange($event)"
           [disabled]="disabled">

    <span class="checkbox-skin"></span>
</label>
